module.exports = __webpack_public_path__ + "7cfacf86d47e69e16e8b262c926c0f88.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/satzung.jpg
// module id = 779
// module chunks = 0